<template>
  <div class="empty">
    <template v-if="!isEmpty">
      <slot></slot>
    </template>
    <div class="empty-msg" v-if="isEmpty">
      <img class="img" src="@/assets/images/empty.png" />
      <div class="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'empty',
  props: {
    isEmpty: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: '暂无数据'
    }
  }
}
</script>

<style lang="scss" scoped>
.empty {
  position: relative;
  min-height: 200px;
  height: 200px;
  .empty-msg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 60px 0;
    .img {
      width: 160px;
    }
    .text {
      font-size: 28rpx;
      color: #525252;
    }
  }
}
</style>
